import { fn_change_step_cd } from "../http/StepConn";
import { prod_sold_out, update_address } from "../http/DetailConn";
import { select_addr_forkakao } from "../http/kakaoConn";
import { select_addr_fornaver_detail_check } from "http/addrConn";
import { select_addr_fornaver, select_addr_fornaver_pos } from "http/addrConn";
import { select_addr_forkakao_pos } from "http/kakaoConn";
import { fn_removeOrderNew, fn_setOrderDetail, fn_closeDetailView } from "./FnBodyDetail";
import {
  api_order_list_get_page,
  api_order_search_list,
  api_order_list,
  reload_order_list_all,
  reload_order_end_list_all,
  api_order_type,
} from "../http/OrderConn";
import { fn_search_tpay_fee } from "../http/dlvTpayConn";
import { fn_deliveryFeeFail, fn_self_delivery_complet } from "./FnBodyLayer";
import { reload_end_order_list } from "../http/EndOrderConn";
import { select_access_token } from "../http/TokenConn";
import {
  fn_bridge_new_order_notify,
  fn_bridge_print,
  fn_bridge_state_notify,
  posBridge,
  fn_bridge_shopinfo_set,
  fn_notify_close,
  fn_bridge_order_status_baemin,
  fn_bridge_order_state,
  fn_bridge_order_cancel_pos,
  fn_bridge_order_accept_pos,
  fn_log_error,
  fn_bridge_pos_order_reload,
  fn_bridge_pos_order_list,
  fn_bridge_text_notify,
} from "./FnPosBridge";
import {
  analyticeEvent,
  apiMobileOrderFg,
  hungryPandaMobileOrderFg,
  posOrderTab,
  posOrdermMbileOrderFg,
} from "utils/Utils";
import { MobileOrderFg, StepCd } from "types";
import { toJS } from "mobx";
import { cancelLayerType } from "utils/CancelLayerType";
/**
 * 스탭변경 함수.
 */

// 주문 상태 변경
export function fn_change_step(rootStore, stepCd, type) {
  const orderStore = rootStore.orderStore;
  const viewStore = rootStore.viewStore;
  // 리스트에서 직접 컨트롤 할 경우가 있어서 해당메뉴를 리스트에서 꺼내서 상세객체이 담기
  viewStore.setOrderDetail(orderStore.getOrderList, viewStore.getOrderDetail.mobileOrderNo);

  fn_send_change_data(rootStore, stepCd, type);
}

export function fn_change_step_one(rootStore, mobileOrderNo, stepCd) {
  const orderStore = rootStore.orderStore;
  const viewStore = rootStore.viewStore;
  // 리스트에서 직접 컨트롤 할 경우가 있어서 해당메뉴를 리스트에서 꺼내서 상세객체이 담기
  viewStore.setOrderDetail(orderStore.getOrderList, mobileOrderNo);
  fn_send_change_data(rootStore, stepCd);
}

// 지난 주문 내역 상태 변경
export function fn_end_order_change_step(rootStore, stepCd) {
  const endOrderStore = rootStore.endOrderStore;
  const viewStore = rootStore.viewStore;

  if (viewStore.getEndOrderViewType == "endOrderView") {
    viewStore.setOrderDetail(endOrderStore.getEndOrderCompleteList, viewStore.getOrderDetail.mobileOrderNo);
  } else {
    viewStore.setOrderDetail(endOrderStore.getEndOrderList, viewStore.getOrderDetail.mobileOrderNo);
  }

  //먹깨비 isNotCallbackReq
  if (rootStore.viewStore.getOrderDetail.mobileOrderFg == "40") {
    rootStore.orderStore.setCompletedCancel(true);
  }
  fn_send_change_data(rootStore, stepCd, "end");
}

export async function fn_send_change_data(rootStore, stepCd, orderType) {
  try {
    await select_access_token(rootStore);

    const viewStore = rootStore.viewStore;
    const layerStore = rootStore.layerStore;
    const searchStore = rootStore.searchStore;

    const payload = {
      shopCd: searchStore.getShopCd,
      saleDate: viewStore.getOrderDetail.saleDate,
      orderNo: viewStore.getOrderDetail?.orderNo,
      mobileOrderFg: viewStore.getOrderDetail?.mobileOrderFg ? viewStore.getOrderDetail.mobileOrderFg : "",
      mobileOrderNo: viewStore.getOrderDetail?.mobileOrderNo,
      mobileOrderNoView: viewStore.getOrderDetail?.mobileOrderNoView,
      stepCd: stepCd,
      deliveryTime: layerStore.getChangeCstTime,
      morderTypeCd: viewStore.getOrderDetail?.morderTypeCd,
      posNo: searchStore.getSession.connPosNo,
      connPosNo: searchStore.getSession.connPosNo,
      cstExpectTime: layerStore.getChangeCstTime,
      cancelReason: layerStore.getChangeCancelReason,
      isNoShow: viewStore.getNoShowCheck,
      isNotCallbackReq: rootStore.orderStore.getCompletedCancel,
    };

    const data = JSON.stringify(payload);
    const res = await fn_change_step_cd(rootStore, data);
    if (res === "000") {
      if (orderType === "end") {
        reload_end_order_list(rootStore);
      } else if (orderType === "posPush") {
        reload_order_end_list_all(rootStore);
      } else {
        reload_order_list_all(rootStore);

        if (rootStore.layerStore.getLayerAlertType) {
          rootStore.layerStore.setLayerAlertView(true);
        }
      }
    } else {
      if (!rootStore.layerStore.getLayerAlertView) {
        rootStore.layerStore.setLayerAlertType("fail");
        rootStore.layerStore.setLayerAlertView(true);
      }

      if (rootStore.layerStore.getPosnotiReject) {
        fn_bridge_text_notify(
          rootStore,
          "거부 처리 실패하였습니다.",
          viewStore.getOrderDetail.orderNo,
          viewStore.getOrderDetail.orderTypeView
        );
        rootStore.layerStore.setPosnotiReject(false);
      }
    }
  } catch (error) {
    console.log("fn_send_change_data", error);
  }
}
// 픽업 호출
export function fn_pickup_order(rootStore) {
  rootStore.layerStore.setLayerAlertType("");
  fn_change_step(rootStore, "300");
}

// 픽업 완료호출
export function fn_pickup_success(rootStore) {
  rootStore.layerStore.setLayerAlertType("");
  fn_change_step(rootStore, "700");
}

// 픽업 완료호출
export function fn_table_accept(rootStore) {
  rootStore.layerStore.setLayerAlertType("");
  fn_change_step(rootStore, "200");
}

// 주문 취소 레이어 호출
export function fn_show_cancel_order(rootStore, mobileOrderNo, bnt) {
  if (rootStore.settingStore.getPosType != "0" && rootStore.settingStore.getPosType != "2") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    analyticeEvent("orderCancel", bnt, rootStore.searchStore.getShopCd); //GA4
    rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
    if (
      rootStore.viewStore.getOrderDetail.mobileOrderFg == "23" ||
      posOrdermMbileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)
    ) {
      fn_show_accept_order_reject(rootStore, mobileOrderNo);
      return;
    }
    fn_removeOrderNew(rootStore, mobileOrderNo);
    rootStore.viewStore.initOrderSoldOutProd();
    if (
      Array.isArray(rootStore.viewStore.getOrderDetail.viewProds) &&
      rootStore.viewStore.getOrderDetail.viewProds.length
    ) {
      for (const prod of rootStore.viewStore.getOrderDetail.viewProds) {
        rootStore.viewStore.addOrderSoldOutProd(prod);
      }
    }

    rootStore.layerStore.setLayerOrderCancel(true);
  }
}

// 주문 거절 레이어 호출
export function fn_show_reject_order(rootStore, mobileOrderNo, type, flag) {
  if (flag == "end") {
    rootStore.viewStore.setOrderEndView(true);
    rootStore.viewStore.setOrderDetail(rootStore.endOrderStore.getEndOrderList, mobileOrderNo);
    if (rootStore.viewStore.getOrderDetail == undefined) {
      rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
    }
  } else {
    rootStore.viewStore.setOrderEndView(false);
    rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  }

  fn_removeOrderNew(rootStore, mobileOrderNo);
  rootStore.viewStore.setOrderEndType(type);
  rootStore.viewStore.initOrderSoldOutProd();
  if (
    Array.isArray(rootStore.viewStore.getOrderDetail.viewProds) &&
    rootStore.viewStore.getOrderDetail.viewProds.length
  ) {
    for (const prod of rootStore.viewStore.getOrderDetail.viewProds) {
      rootStore.viewStore.addOrderSoldOutProd(prod);
    }
  }

  rootStore.layerStore.setLayerOrderReject(true);
}

// 주문 호출
export function fn_show_call(rootStore, mobileOrderNo) {
  const { viewStore, orderStore } = rootStore;
  fn_removeOrderNew(rootStore, mobileOrderNo);
  viewStore.setOrderDetail(orderStore.getOrderList, mobileOrderNo);

  fn_change_step(rootStore, StepCd.PICKUP_REQUEST);
}

// 재출력 체크로직
export function fn_print_check_receipt(rootStore) {
  let cnt = 0;
  let printList = rootStore.settingStore.getEtcPrinterInfo.defaultPrintSettings;
  let addPrintList = rootStore.settingStore.getEtcPrinterInfo.addPrintSettings;
  let totalPrintList = [];

  if (addPrintList.length != 0) {
    for (let i = 0; i < addPrintList.length; i++) {
      totalPrintList.push(addPrintList[i]);
    }
  }

  for (let i = 0; i < printList.length; i++) {
    if (printList[i].type == "01") {
      totalPrintList.push(printList[i]);
    }
  }

  if (rootStore.settingStore.getPrinterInfo.etcPrinterFlag == "Y") {
    for (let i = 0; i < totalPrintList.length; i++) {
      if (totalPrintList[i].useYn == "Y") {
        cnt++;
        break;
      }
    }
  }

  if (rootStore.settingStore.getPrinterInfo.etcKitchenPrinterFlag == "Y") {
    for (let i = 0; i < printList.length; i++) {
      if (printList[i].portNo != "COM0") {
        if (printList[i].type != "01" && printList[i].useYn == "Y") {
          cnt++;
          break;
        }
      }
    }
  }

  return cnt;
}

// 영수증 출력
export function fn_print_receipt(rootStore, mobile_order_no, printFormCheck) {
  if (
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "23" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "20" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "18" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "00" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "24" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "37" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "48" &&
    rootStore.viewStore.getOrderDetail.mobileOrderFg != "51"
  ) {
    if (fn_print_check_receipt(rootStore) == 2) {
      rootStore.layerStore.setLayerReprint(true);
      if (printFormCheck) {
        rootStore.layerStore.setLayerReprint(true);
      } else {
        fn_bridge_print(rootStore, "2");
      }
    } else if (fn_print_check_receipt(rootStore) == 1) {
      fn_bridge_print(rootStore, "5");
    } else {
      rootStore.layerStore.setLayerPrintSetType("print");
      rootStore.layerStore.setLayerAlertType("print_setting");
      rootStore.layerStore.setLayerAlertView(true);
    }
  } else {
    if (printFormCheck) {
      rootStore.layerStore.setLayerReprint(true);
    } else {
      fn_bridge_print(rootStore, "2");
    }
  }
}

// 배달요청 레이어 호출
export function fn_delivery_call(rootStore, mobile_order_no, btn) {
  analyticeEvent("riderCall", btn, rootStore.searchStore.getShopCd); //GA4
  select_access_token(rootStore).then(res => {
    fn_removeOrderNew(rootStore, mobile_order_no);

    const orderList = rootStore.orderStore.getOrderList;
    rootStore.viewStore.setOrderDetail(orderList, mobile_order_no);

    rootStore.viewStore.setDetailSearchAddr(rootStore.viewStore.getOrderDetail.dlvAddr);

    let delivery_arr = rootStore.deliveryStore.getExpDelivery;
    let delivery_yn_arr = rootStore.settingStore.getPayFreeType.useDeliveryResList; //연동대행사중 사용하는list
    let delivery_new_array = [];

    delivery_arr.map((element, i) => {
      delivery_yn_arr.map(name => {
        if (element.delivery_code == name.codeName && name.useYn == "Y") {
          delivery_new_array.push(element);
        }
      });
    });

    //배달대행사 초기화 후 사용중인 배달대행사 넣기
    rootStore.deliveryStore.setinitDelivery();
    rootStore.deliveryStore.setExpDelivery(delivery_new_array);

    //select_addr_forkakao_detail_check(rootStore).then(r => {
    select_addr_fornaver_detail_check(rootStore, "detail").then(r => {
      if (rootStore.viewStore.getSelectedAddr != null) {
        rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobile_order_no);
        rootStore.deliveryStore.setDeliveryTab("ext"); // 최초 대행업체 호출

        // 배달비요청을 위해 초기 객체 셋팅 ( 0번째 객체 )
        if (rootStore.deliveryStore.getExpDelivery.length > 0) {
          rootStore.deliveryStore.getExpDelivery.map((dlv, index) => {
            rootStore.deliveryStore.setDxtDetail(dlv);
            if (dlv.type === "TPAY") {
              fn_search_tpay_fee(rootStore).then(res => {
                if (res === "1") {
                  // 배달대행사가 다수일 경우가 있어 조회 데이터 중 선택된 정보로 최종 store 변경 처리.
                  let data = rootStore.deliveryStore.getExpDeliverySelect;
                  rootStore.deliveryStore.setDxtDetail(data);
                  rootStore.deliveryStore.setExpDeliveryFeeSelect(data);
                } else {
                  fn_deliveryFeeFail(rootStore);
                }
                rootStore.layerStore.setLayerDeliveryCall(true); // 조회 완료시 배달레이어 오픈
              });
            }
            return dlv;
          });
        } else {
          rootStore.layerStore.setLayerDeliveryCall(true); // 조회 완료시 배달레이어 오픈
        }
      } else {
        rootStore.layerStore.setLayerAlertType("delivery_fail");
        rootStore.layerStore.setLayerAlertView(true);
      }
    });
  });
}

export function fn_delivery_call_not_check(rootStore, mobile_order_no) {
  select_access_token(rootStore).then(res => {
    if (rootStore.viewStore.getSelectedAddr != null) {
      rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobile_order_no);
      rootStore.deliveryStore.setDeliveryTab("ext"); // 최초 대행업체 호출

      // 배달비요청을 위해 초기 객체 셋팅 ( 0번째 객체 )
      if (rootStore.deliveryStore.getExpDelivery.length > 0) {
        rootStore.deliveryStore.getExpDelivery.map((dlv, index) => {
          if (index === 0) {
            rootStore.deliveryStore.setDxtDetail(dlv);
            if (dlv.type === "TPAY") {
              fn_search_tpay_fee(rootStore, true).then(res => {
                if (res === "1") {
                  rootStore.layerStore.setLayerDeliveryCall(true); // 조회 완료시 배달레이어 오픈
                } else {
                  fn_deliveryFeeFail(rootStore);
                }
              });
            }
          }

          return dlv;
        });
      } else {
        rootStore.layerStore.setLayerDeliveryCall(true); // 조회 완료시 배달레이어 오픈
      }
    } else {
      rootStore.layerStore.setLayerAlertType("delivery_fail");
      rootStore.layerStore.setLayerAlertView(true);
    }
  });
}

// 배차취소
export function fn_delivery_cancel(rootStore, order) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, order.mobileOrderNo);
  rootStore.layerStore.setLayerAlertType("delivery_order_cancel_check");
  rootStore.layerStore.setLayerAlertView(true);
}

export function fn_sold_out(rootStore) {
  // 품절 처리 후 상태 변경
  select_access_token(rootStore).then(res => {
    prod_sold_out(rootStore);
  });
}

// 주소정보 업데이트
export function fn_update_address(rootStore, addAdress) {
  rootStore.viewStore.setDetailSearchAddrDetail(addAdress.trim());
  // 품절 처리 후 상태 변경
  select_access_token(rootStore).then(res => {
    update_address(rootStore);
  });
}

// 주소api분기
export function fn_address_api(rootStore, api) {
  rootStore.viewStore.setAddrApiName("api", api);
  if (rootStore.viewStore.getAddrApiName.api === "kakao") {
    select_addr_forkakao(rootStore);
  } else {
    select_addr_fornaver(rootStore);
  }
}

// 주소api분기 Pos
export function fn_address_api_pos(rootStore, api) {
  rootStore.addressSearchStore.setAddrApiName("api", api);
  if (rootStore.addressSearchStore.getAddrApiName.api === "kakao") {
    select_addr_forkakao_pos(rootStore);
  } else {
    select_addr_fornaver_pos(rootStore);
  }
}

export function fn_order_complete(rootStore, mobileOrderNo) {
  fn_setOrderDetail(rootStore, mobileOrderNo, "order").then(r => {
    if (
      rootStore.viewStore.getOrderDetail.orderType === "DELIVERY" &&
      rootStore.viewStore.getOrderDetail.dlvTargetCd == null
    ) {
      fn_self_delivery_complet(rootStore, true, mobileOrderNo);
    } else {
      fn_change_step(rootStore, "700");
    }
  });
}

/** ------------------- 주문 취소 레이어 호출 로직 ------------------- */
export function fn_show_end_order_cancel(rootStore, mobileOrderNo, type) {
  analyticeEvent("orderCancel", "orderCancelOldDetail Button", rootStore.searchStore.getShopCd); //GA4
  const { viewStore, layerStore } = rootStore;
  const mobileOrderFg = viewStore.getOrderDetail.mobileOrderFg;

  const layerType = cancelLayerType(mobileOrderFg, type);
  layerStore.setLayerAlertType(layerType);
  layerStore.setLayerAlertView(true);
}

// 후킹 주문 취소 레이어 호출
export function fn_show_hooking_order_cancel(rootStore, mobileOrderNo, btn) {
  if (rootStore.settingStore.getPosType != "0" && rootStore.settingStore.getPosType != "2") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    analyticeEvent("orderCancel", btn, rootStore.searchStore.getShopCd); //GA4
    rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
    if (rootStore.viewStore.getOrderDetail.mobileOrderFg == "23") {
      fn_show_new_order_reject(rootStore, mobileOrderNo);
      return;
    }
    fn_removeOrderNew(rootStore, mobileOrderNo);
    rootStore.layerStore.setLayerAlertType("order_cancel");
    rootStore.layerStore.setLayerAlertView(true);
  }
}

// 후킹 주문 거절 레이어 호출
export function fn_show_hooking_order_reject(rootStore, mobileOrderNo) {
  fn_removeOrderNew(rootStore, mobileOrderNo);
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  rootStore.layerStore.setLayerAlertType("order_reject");
  rootStore.layerStore.setLayerAlertView(true);
}

//주문거절-일반
export function fn_show_new_order_reject(rootStore, mobileOrderNo) {
  fn_removeOrderNew(rootStore, mobileOrderNo);
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  rootStore.layerStore.setLayerAlertType("order_nosoldout_reject");
  rootStore.layerStore.setLayerAlertView(true);
}

export function fn_show_accept_order_reject(rootStore, mobileOrderNo, btn) {
  const { viewStore, settingStore, layerStore, orderStore, endOrderStore } = rootStore;
  const { getPosType } = settingStore;
  const orderDetail = viewStore.getOrderDetail;
  if (getPosType !== "0" && getPosType !== "2") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
    return;
  }

  if (btn) {
    if (posOrdermMbileOrderFg(orderDetail.mobileOrderFg)) analyticeEvent("kdsOrderCancel", btn, "Button"); //GA4
    else analyticeEvent("orderCancel", btn, rootStore.searchStore.getShopCd); //GA4
  }

  const orderList = btn === "kdsOrderCancelOldDetail Button" ? endOrderStore.getEndOrderList : orderStore.getOrderList;
  viewStore.setOrderDetail(orderList, mobileOrderNo);

  const removeOrder = () => {
    fn_removeOrderNew(rootStore, mobileOrderNo);
    rootStore.layerStore.setLayerAlertType("order_accept_reject");
    rootStore.layerStore.setLayerAlertView(true);
  };

  // 취소 가능한 채널
  const rejectChannels = [
    MobileOrderFg.NAVER,
    MobileOrderFg.KIOSK,
    MobileOrderFg.POS_PREPAID,
    MobileOrderFg.TABLE_ORDER,
    MobileOrderFg.QR_ORDER,
  ];

  //매장주문 취소
  if (orderDetail.morderTypeCd === "O") {
    if (rejectChannels.includes(orderDetail.mobileOrderFg)) removeOrder();
    else {
      fn_removeOrderNew(rootStore, mobileOrderNo);
      viewStore.initOrderSoldOutProd();
      if (Array.isArray(orderDetail.viewProds) && orderDetail.viewProds.length) {
        for (const prod of orderDetail.viewProds) {
          viewStore.addOrderSoldOutProd(prod);
        }
      }
      layerStore.setLayerOrderReject(true);
    }
  } else {
    if (hungryPandaMobileOrderFg(orderDetail.mobileOrderFg)) fn_show_cancel_panda(rootStore);
    else removeOrder();
  }
}

// 리스트 재호출 클릭 호출
export function fn_recall(rootStore, mobileOrderNo) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  fn_change_step(rootStore, "300");
}

export function fn_order_set_state(rootStore, data) {
  let notifyText;
  let typeName;

  if (data.type != "") {
    //자동주문완료시 두번내려옴 (임시수정)
    if (data.type === "create") {
      //주문접수시 전체탭으로 이동
      rootStore.orderStore.setPagingInfo("page_no", 1);
      rootStore.searchStore.setCurrOrderType("all");
      rootStore.settingStore.setKioskOrderState("all");

      fn_log_error("", "create", JSON.stringify(data));
      data = {
        ...rootStore.orderStore.viewMobileOrderNoCreate(data),
        localDeliveryDfTime: rootStore.settingStore.getDeliveryDfTime,
        localCookingDfTime: rootStore.settingStore.getCookingDfTime,
      };
      if (data.mobileOrderFg !== MobileOrderFg.HOOKING) fn_bridge_new_order_notify(rootStore, data);
    } else if (data.type === "memo") {
      reload_order_list_all(rootStore, rootStore.searchStore.getCurrOrderType);
    } else {
      typeName = getOrderTypeName(data.morderTypeCd);
      if (data.type != "allCompletedOrder") {
        data = rootStore.orderStore.viewMobileOrderNoCreate(data);
      }
      switch (data.type) {
        case "HOOKING_ORDER_NEW":
          notifyText = "자동접수 처리되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, dlvStatusFg: "01", orderTypeView: typeName };
          //api_notify_reload(rootStore)
          break;
        case "CID_ORDER_NEW":
          notifyText = "접수 처리되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          if (data.modifyFg === "MODIFY") {
            notifyText = "주문이 수정되었습니다.";
          }
          data = { ...data, dlvStatusFg: "01", orderTypeView: typeName };
          break;
        case "orderNo":
        case "orderno":
        case "ORDER_NO":
          notifyText = "접수 처리되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, dlvStatusFg: "01", orderTypeView: typeName };
          break;
        case "cancel":
          notifyText = "취소건으로 처리되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, dlvStatusFg: "99", orderTypeView: typeName };
          if (apiMobileOrderFg(data.mobileOrderFg)) {
            fn_notify_close(rootStore);
          }
          break;
        case "dlv_status":
          if (data.dlvStatusFg === "02") {
            //배차알림 sendAlarm
            notifyText = "라이더가 배차되었습니다.";
            rootStore.settingStore.setPosNotifySound("sendAlarm");

            //배달의민족 배달상태 업데이트(픽업중)
            if (data.mobileOrderFg == "28") {
              fn_bridge_order_status_baemin(rootStore, data, "RIDER_ASSIGNED");
            }
          } else if (data.dlvStatusFg === "03") {
            //픽업알림 pickupAlarm
            notifyText = "라이더가 픽업하였습니다.";
            rootStore.settingStore.setPosNotifySound("pickupAlarm");

            //배달의민족 배달상태 업데이트(배달중)
            if (data.mobileOrderFg == "28") {
              fn_bridge_order_status_baemin(rootStore, data, "PICKUP_COMPLETED");
            }
          } else if (data.dlvStatusFg === "04") {
            notifyText = "배달이 완료되었습니다.";
            rootStore.settingStore.setPosNotifySound("deliveryAlarm");

            //배달의민족 배달상태 업데이트(완료)
            if (data.mobileOrderFg == "28") {
              fn_bridge_order_status_baemin(rootStore, data, "DELIVERY_COMPLETED");
            }
          } else if (data.dlvStatusFg === "99") {
            notifyText = "배달접수가 취소되었습니다.";
            rootStore.settingStore.setPosNotifySound("default");
          }
          data = {
            ...data,
            dlvStatusFg: data.dlvStatusFg,
            orderTypeView: typeName,
          };
          break;
        case "self_delivery_status":
          if (data.stepCd === "500") {
            //픽업알림 pickupAlarm
            notifyText = "라이더가 픽업하였습니다.";
            rootStore.settingStore.setPosNotifySound("pickupAlarm");
            data = {
              ...data,
              dlvStatusFg: data.dlvStatusFg,
              orderTypeView: typeName,
            };
          }
          break;
        case "order_complete":
          //if (data.dlvStatusFg != "04") {
          notifyText = "완료건으로 처리되었습니다."; //픽업완료todo
          rootStore.settingStore.setPosNotifySound("default");

          //배달의민족 배달상태 업데이트(픽업중)
          // if (data.morderTypeCd === "P" && (data.mobileOrderFg == "28" || data.mobileOrderFg == "30")) {
          //     fn_bridge_order_status_baemin(rootStore, data, "DELIVERY_COMPLETED")
          // }

          if (data.morderTypeCd === "D") {
            data = { ...data, dlvStatusFg: "04", orderTypeView: typeName };
          } else {
            //픽업의 경우 fg값 정의 안된 값으로 전달
            data = { ...data, dlvStatusFg: "99", orderTypeView: typeName };
          }
          //}
          break;
        case "dlvReq":
          notifyText = "라이더 콜이 접수되었습니다."; //접수알림 callAlarm
          rootStore.settingStore.setPosNotifySound("callAlarm");
          //배달의민족 배달상태 업데이트
          if (data.mobileOrderFg == "28") {
            fn_bridge_order_status_baemin(rootStore, data, "AGENCY_ASSIGNED");
          }
          data = { ...data, orderTypeView: typeName };
          break;
        case "pickReq":
          notifyText = "픽업요청 알림이 발송되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          break;
        case "dlvCancel":
          notifyText = "배차 요청이 취소되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = {
            ...data,
            dlvStatusFg: data.dlvStatusFg,
            orderTypeView: typeName,
          };
          break;
        case "allCompletedOrder":
          notifyText = "";
          rootStore.settingStore.setPosNotifySound("default");
          break;
        case "autoCancel":
          notifyText = "접수 지연으로 자동 취소되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          fn_notify_close(rootStore);
          break;
        case "cancel_before_accept":
          notifyText = "고객 요청으로 취소되었습니다.";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          fn_notify_close(rootStore);
          //api_notify_reload(rootStore)
          break;
        case "create_order_no":
          fn_bridge_order_state(rootStore, data.mobileOrderNo, "", data.orderNo, true);
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          fn_notify_close(rootStore);
          //api_notify_reload(rootStore)
          break;
        case "dlv_status_cook":
          notifyText = "라이더 조리를 요청했습니다.";
          //ootStore.settingStore.setPosNotifySound("default")
          rootStore.settingStore.setPosNotifySound("COOK");
          data = { ...data, orderTypeView: typeName };
          break;
        case "create_sale":
          //매출 생성 큐
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          fn_bridge_order_accept_pos(rootStore, data);
          break;
        case "cancel_sale":
          //매출 취소 큐
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          fn_bridge_order_cancel_pos(rootStore, data);
          break;
        case "partial_cancel":
          notifyText = "부분 취소가 발생했습니다";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          break;
        case "cook_completed":
          notifyText = "준비완료 처리되었습니다";
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          break;
        case "kds_status_changed":
          if (data.stepCd === "200") {
            notifyText = "조리중으로 변경되었습니다";
          } else if (data.stepCd === "300") {
            notifyText = "알림이 발송되었습니다";
          } else if (data.stepCd === "700") {
            notifyText = "완료건으로 처리되었습니다";
          } else if (data.stepCd === "900") {
            notifyText = "취소건으로 처리되었습니다";
          }
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          break;

        default:
          rootStore.settingStore.setPosNotifySound("default");
          data = { ...data, orderTypeView: typeName };
          break;
      }

      if (rootStore.settingStore.getManagerSetting?.orderEnd == "Y" && data.type != "order_complete") {
        rootStore.settingStore.setManagerSetting("orderEnd", "N");
        rootStore.settingStore.setKioskOrderState("all");
        fn_bridge_shopinfo_set(rootStore);
      }

      notifyReload(rootStore, data, notifyText);
    }
  }
}

export function notifyReload(rootStore, data, notifyText) {
  fn_log_error("", "data.type", data.type);

  if (data.type != "create_sale" && data.type != "cancel_sale") {
    if (posOrderTab(rootStore)) {
      fn_bridge_pos_order_list(rootStore);
      fn_bridge_state_notify(rootStore, data, notifyText);
      api_order_type(rootStore);
    } else {
      api_order_list_get_page(rootStore, data.mobileOrderNo, true).then(r => {
        api_order_search_list(rootStore).then(r => {
          if (data.type != "create_order_no") {
            fn_log_error("notify호출", "", data.type);
            fn_bridge_state_notify(rootStore, data, notifyText);
          }
          api_order_type(rootStore);
          api_order_list(rootStore);
          if (data.type == "cancel") {
            //취소시 지난주문내역 조회
            reload_end_order_list(rootStore);
          }
          if (data.orderNo == rootStore.viewStore.getOrderDetail.orderNo) {
            fn_closeDetailView(rootStore);
          }
        });
      });
    }
  }
}

export function getOrderTypeName(type) {
  let result = "";
  let pattern = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

  //타입이 한글로 직접 오는 경우도 있음
  if (pattern.test(type)) {
    return type;
  }
  if (type === "D") {
    result = "배달";
  } else if (type === "P") {
    result = "포장";
  } else if (type === "T") {
    result = "매장";
  } else if (type === "O") {
    result = "매장";
  }

  return result;
}

export function fn_send_order_complete_bottom(rootStore, mobileOrderNo) {
  fn_removeOrderNew(rootStore, mobileOrderNo);
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  fn_change_step(rootStore, "700");

  rootStore.layerStore.setLayerOrderComplete(false);
}

// 여기
export async function fn_send_order_delivery_complete(rootStore) {
  const { orderStore, viewStore, layerStore } = rootStore;
  viewStore.setOrderDetail(orderStore.getOrderList, viewStore.getOrderDetail.mobileOrderNo);

  layerStore.setLayerOrderComplete(false);
  await fn_send_change_data(rootStore, "700", "");
}

export function fn_no_show_allowed_time(rootStore) {
  var dateString = rootStore.viewStore.getOrderDetail.noShowAllowedTime;
  var dateObject = new Date(dateString);
  var now = new Date();

  if (now > dateObject) {
    rootStore.viewStore.setNoShowCheck(true);
    rootStore.layerStore.setLayerAlertType("no_show_allowed_success");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    rootStore.layerStore.setLayerAlertType("no_show_allowed_fail");
    rootStore.layerStore.setLayerAlertView(true);
  }
}

export function fn_emergency_notice(rootStore, data) {
  rootStore.settingStore.setEmergencyNotice("title", data.title);
  rootStore.settingStore.setEmergencyNotice("content", data.content);
  rootStore.settingStore.setEmergencyNotice("type", data.type);

  let ret = posBridge(
    rootStore,
    `{'command' : 'EMERGENCY_NOTICE', 'data' : '{"title":"${data.title}","content":"${data.content}","type":"${data.type}"}'}`
  );
}

// 주문 호출
export function fn_show_cancel_panda(rootStore) {
  rootStore.layerStore.setLayerAlertType("panda_cancel");
  rootStore.layerStore.setLayerAlertView(true);
}

// pos/kiosk주문 notify설정
export function fn_pos_order_notify_setting(rootStore, data) {
  if (posOrderTab(rootStore)) {
    fn_bridge_pos_order_reload(rootStore);
  } else {
    api_order_list(rootStore);
    fn_closeDetailView(rootStore);
  }
  api_order_type(rootStore);

  let notifyText = "";

  data.mobileOrderNoView = data.orderNo;

  if (data.orderTypeView === "O") {
    data.orderTypeView = "매장";
  } else {
    data.orderTypeView = "포장";
  }

  if (data.stepCd === "200") {
    notifyText = "조리중으로 변경되었습니다.";
  } else if (data.stepCd === "300") {
    notifyText = "알림이 발송되었습니다.";
  } else if (data.stepCd === "700") {
    notifyText = "완료건으로 처리되었습니다.";
  } else if (data.stepCd === "900") {
    notifyText = "취소건으로 처리되었습니다.";
  }

  fn_bridge_state_notify(rootStore, data, notifyText);
}
